import type { Observation, SimulationDataset, VisualFeature } from "../simulator/types";
import type { Box, Detection, ObjectKind, VisualEncounter } from "./types";

export function classFeature(kind: ObjectKind): VisualFeature {
    return kind === "traffic_light" ? { kind: "traffic_light", signCode: "", signValue: "" }
        : { kind: "road_sign", signCode: "2.2", signValue: "" };
}

export function modelDetection(label: string, score: number, bbox: number[], width: number, height: number): Detection | null {
    const kind = label === "traffic light" ? "traffic_light" : label === "stop sign" ? "stop_sign" : null;
    if (!kind || !Number.isFinite(score) || score < 0 || score > 1 || bbox.length !== 4 || bbox.some(value => !Number.isFinite(value)) || width <= 0 || height <= 0) return null;
    const [x, y, w, h] = bbox;
    const left = Math.max(0, Math.min(1, x / width)), top = Math.max(0, Math.min(1, y / height));
    const right = Math.max(0, Math.min(1, (x + w) / width)), bottom = Math.max(0, Math.min(1, (y + h) / height));
    if (right - left < 0.005 || bottom - top < 0.005) return null;
    return { kind, score, box: [left, top, right - left, bottom - top] as Box };
}

export function cameraDataset(dataset: SimulationDataset): SimulationDataset {
    // Unobservable classes must not be treated as missed camera detections.
    const landmarks = dataset.landmarks.filter(landmark => landmark.kind === "traffic_light" ||
        (landmark.kind === "road_sign" && landmark.signCode.trim().replace(/^UA:/i, "") === "2.2"));
    return { ...dataset, landmarks, presets: [], estimatedLandmarks: landmarks.filter(landmark => landmark.estimatedBinding).length,
        excludedLandmarks: landmarks.filter(landmark => !landmark.bindings.length).length };
}

export function encounterObservation(encounter: VisualEncounter): Observation {
    return { trackId: encounter.id, timestampMs: encounter.timestampMs,
        features: [{ ...encounter.feature, confidence: encounter.confidence }], distance: null, courseChange: null };
}
